import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Scrollbar, SpinnerLoader, Tabs, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type Campaign } from 'entities/Campaign'
import { CampaignStatus } from 'entities/Campaign/ui/CampaignStatus'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CampaignDetailsModalStore } from '../store/campaignDetailsModalStore'
import { EnrollContacts } from './tabs/EnrollContacts/EnrollContacts'

import styles from './styles.module.scss'
import { Steps } from './tabs/Steps/Steps'

const Content = observer(
  ({ item, store }: { item: Campaign; store: CampaignDetailsModalStore }) => {
    const { loading, tabs, activeTabKey, setActiveTab } = store

    return (
      <div className={styles.wrap}>
        <div className={styles.title}>
          <Typography ariaLabel={getAriaLabel('campaignName')} variant={'heading-lg'} ellipsis>
            {item.name}
          </Typography>
        </div>
        <div className={styles.status}>
          <CampaignStatus status={item.status} />
        </div>

        {loading ? (
          <SpinnerLoader ariaLabel={'CampaignDetailsModalContent'} />
        ) : (
          <div className={styles.content}>
            <div className={styles.tabs}>
              <Tabs tabs={tabs} activeTabKey={activeTabKey} handleSelectTab={setActiveTab} />
            </div>
            <Scrollbar marginHeight={50} height={'calc(100% - 28px)'}>
              {activeTabKey === 'enrollContacts' && <EnrollContacts store={store} />}
              {activeTabKey === 'steps' && <Steps store={store} />}
            </Scrollbar>
          </div>
        )}
      </div>
    )
  }
)

export const CampaignDetailsModalContent = observer(({ item }: { item: Campaign }) => {
  const entities = useEntitiesContext()
  const store = new CampaignDetailsModalStore(entities)

  useEffect(() => {
    store.setId(item.id)
  }, [item.id])

  return <Content item={item} store={store} />
})
